import React from 'react';
import { Navigate, useParams } from 'react-router-dom';

export const GroupLinkShare = () => {
  const params = useParams();

  return <Navigate to={`/group/detail/${params.code}`} />;
};
